<template>
  <a
  v-if="loginStatus"
  class="d-block position-absolute edit-button shadow"
  :href="`${boltBE}${contentType}/${itemId}`"
  target="_blank"

  >
    <b-img
      src="/img/icons/outline-edit-24px.svg"
    />
  </a>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: {
    contentType: String,
    itemId: String
  },
  name: 'editButton',
  data () {
    return {

    }
  },
  components: {

  },
  computed: {
    ...mapGetters({
      boltBE: 'getBoltBE',
      loginStatus: 'getBoltLoginStatus'
    })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.edit-button {
  bottom: 0;
  right: 0;
  padding: .6rem;
  background: #fff;
  border: 2px solid #ddd;
  border-radius: 50%;

}
</style>
